export default __webpack_public_path__ + "static/media/gallery_07.124b6e31.jpg";